import instance from "../utils/network";

export interface GameInspectionSchedule {
  isInspection: boolean;
  endAt: string;
}
export function getGameInspectionSchedule(): Promise<GameInspectionSchedule> {
  return instance.get(`/game-inspection-schedule`);
}
